import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';

import { type User } from '@/auth';

import TrashedPdfList from './TrashedPdfList';

type Props = {
    user: User;
};

export default function RecycleBin(props: Props) {
    const tenantId = props.user.tenantId;
    const recycleBinPath = 'stable/recyclebin/' + tenantId + '/';

    return (
        <>
            <Card sx={{ border: 1, borderColor: 'warning.main', boxShadow: 0, marginTop: 2, marginLeft: 2, marginRight: 2 }}>
                <Alert severity="warning" sx={{ width: '100%' }} style={{ whiteSpace: 'nowrap' /* 改行による横スクロールバーのズレを防ぐ */ }}>
                    ゴミ箱内のドキュメントはおおよそ７日後に完全に削除されます
                </Alert>
            </Card>
            <Grid container>
                <Grid size={12} display="flex" justifyContent="center">
                    <Box sx={{ width: '100%' }}>
                        <TrashedPdfList path={recycleBinPath} />
                    </Box>
                </Grid>
            </Grid>
        </>
    );
}
